module.exports = __webpack_public_path__ + "static/media/ePosterHealthcare.35392fc8.jpg";